export const BREADCRUMB_SEGMENTS = {
  // MAIN SECTIONS - Sidebar
  INSIGHTS: 'insights',
  INSIGHTS_PRO: 'insights',
  ARTICLE_VISIBILITY: 'articlevisibility',
  BENCHMARKING: 'benchmarking',
  API: 'api',
  TRADING: 'trading',
  // TABS - Insights
  PERFORMANCE: 'performance', // - also used in benchmarking
  MARKETPLACE: 'marketplace',
  COUNTRY: 'country',
  CATEGORY: 'category',
  PRODUCT: 'product',
  // TABS - Benchmarking
  MARKETPLACES: 'marketplaces',
  COUNTRIES: 'countries',
  CATEGORIES: 'categories',
  // TABS - API
  ABOUT: 'about',
  TOKEN: 'token',
  DOCUMENTATION: 'documentation',
  // SUB-SECTIONS - GENERAL
  PRODUCTS: 'products',
  REPORTS: 'reports',
} as const;

export type BreadcrumbSegment = (typeof BREADCRUMB_SEGMENTS)[keyof typeof BREADCRUMB_SEGMENTS];
